import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Youtube, BellRing, Check } from "lucide-react";

interface YoutubeSubscribeProps {
 channelId?: string;
 channelName?: string;
}

const YoutubeSubscribe = ({ 
 channelId = "UCMg7hfAaY5ujTtMSHiHmezg", 
 channelName = "@byhudsonraone" 
}: YoutubeSubscribeProps) => {
 const [isHovered, setIsHovered] = useState(false);
 const [subscribed, setSubscribed] = useState(false);

 const handleSubscribeClick = () => {
 window.open(`https://www.youtube.com/@byhudsonraone?sub_confirmation=1`, '_blank');
 // Simulamos um estado de inscrito local para feedback visual imediato, 
 // embora a inscrição real ocorra na aba do YouTube.
 setSubscribed(true);
 setTimeout(() => setSubscribed(false), 5000); // Reseta após 5s para permitir nova interação se desejar
 };

 return (
 <div className="w-full max-w-4xl mx-auto mb-6 px-1">
 <motion.div
 initial={{ opacity: 0, y: 10 }}
 animate={{ opacity: 1, y: 0 }}
 className="relative p-[1px] rounded-2xl overflow-hidden group shadow-2xl"
 onMouseEnter={() => setIsHovered(true)}
 onMouseLeave={() => setIsHovered(false)}
 >
 {/* Borda Animada (Laranja) */}
 <div 
 className="absolute inset-0 bg-gradient-to-r from-transparent via-[#FF6A00] to-transparent bg-[length:200%_100%] animate-shimmer opacity-40 group-hover:opacity-100 transition-opacity duration-500"
 />

 <div className="relative bg-[#0F0F0F] rounded-[15px] p-4 md:p-5 flex flex-col sm:flex-row items-center justify-between gap-4 border border-foreground/10 z-10">
 <div className="flex items-center gap-4 w-full sm:w-auto">
 <div className="relative flex-shrink-0">
 <div className="w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden border-2 border-[#FF6A00]/30 bg-secondary shadow-lg">
 <img 
 src="https://yt3.googleusercontent.com/baBP82JDxapLQXQrC5kNbEh6asEUXDCevQk0MZdbrcFYnVHdrbuhdwkmKwKzDsr5Wb1sNqhl3w=s160-c-k-c0x00ffffff-no-rj" 
 alt="Channel Icon"
 className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
 onError={(e) => {
 (e.target as HTMLImageElement).src = "https://images.unsplash.com/photo-1611605698335-8b1569810432?w=100&h=100&fit=crop";
 }}
 />
 </div>
 <div className="absolute -bottom-1 -right-1 bg-[#FF6A00] rounded-full p-1 border-2 border-[#0F0F0F]">
 <Youtube className="w-2.5 h-2.5 text-foreground" />
 </div>
 </div>
 
 <div className="flex flex-col min-w-0">
 <span className="text-base md:text-lg font-display font-bold text-foreground truncate leading-tight">
 {channelName}
 </span>
 <span className="text-xs text-muted-foreground flex items-center gap-1.5 mt-0.5">
 <span className="w-1.5 h-1.5 rounded-full bg-red-600 animate-pulse" />
 Conteúdo Exclusivo no YouTube
 </span>
 </div>
 </div>

 <div className="flex items-center gap-3 w-full sm:w-auto justify-end">
 <AnimatePresence mode="wait">
 {!subscribed ? (
 <motion.button
 key="subscribe-btn"
 initial={{ opacity: 0, scale: 0.9 }}
 animate={{ opacity: 1, scale: 1 }}
 exit={{ opacity: 0, scale: 1.1 }}
 whileHover={{ scale: 1.05 }}
 whileTap={{ scale: 0.95 }}
 onClick={handleSubscribeClick}
 className="flex-1 sm:flex-none bg-[#FF6A00] text-foreground font-black px-6 md:px-8 py-3 rounded-full text-xs md:text-sm flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(255,106,0,0.4)] hover:shadow-[0_0_35px_rgba(255,106,0,0.6)] transition-all uppercase tracking-wider h-12"
 >
 <Youtube className="w-4 h-4 md:w-5 md:h-5" /> 
 Inscrever-se
 </motion.button>
 ) : (
 <motion.div
 key="subscribed-state"
 initial={{ opacity: 0, scale: 0.9 }}
 animate={{ opacity: 1, scale: 1 }}
 className="flex-1 sm:flex-none bg-foreground/10 text-[#FF6A00] font-black px-6 md:px-8 py-3 rounded-full text-xs md:text-sm flex items-center justify-center gap-2 border border-[#FF6A00]/50 h-12 uppercase tracking-wider"
 >
 <Check className="w-4 h-4 md:w-5 md:h-5" /> 
 Inscrito
 </motion.div>
 )}
 </AnimatePresence>
 
 <motion.div
 animate={isHovered ? { 
 rotate: [0, -10, 10, -10, 10, 0],
 scale: [1, 1.1, 1]
 } : {}}
 transition={{ repeat: Infinity, duration: 1.5 }}
 className="hidden md:flex p-3 rounded-full bg-foreground/10 border border-foreground/10 text-muted-foreground hover:text-[#FF6A00] hover:border-[#FF6A00]/30 transition-all cursor-help"
 >
 <BellRing className="w-5 h-5" />
 </motion.div>
 </div>
 </div>
 </motion.div>

 <style>{`
 @keyframes shimmer {
 0% { background-position: -200% 0; }
 100% { background-position: 200% 0; }
 }
 .animate-shimmer {
 animation: shimmer 4s infinite linear;
 background: linear-gradient(90deg, transparent, #FF6A00, transparent);
 background-size: 200% 100%;
 }
 `}</style>
 </div>
 );
};

export default YoutubeSubscribe;
